export default {};throw new Error(`Could not resolve "@farcaster/mini-app-solana" imported by "@privy-io/react-auth".`)